// Beliggenhet
export default function() {
  return [
    {
      component: 'Section',
      props: {
        width: 'full',
        class: 'post__header',
      },
      blocks: {
        default: [
          {
            component: 'Slider',
            props: {
              aspectRatio: '21/9',
              class: 'subpage-hero',
            },
            data: this.media.cover,
          },
        ],
      },
    },

    {
      component: 'Section',
      props: {
        class: 'post__plot-section',
        width: 'full',
      },
      blocks: {
        default: [
          {
            component: 'Text',
            props: {
              class: 'post__content',
            },
            data: {
              content: this.content,
            },
          },
        ],
      },
    },

    {
      component: 'Section',
      props: {
        class: 'post__plot',
        width: 'small',
      },
      blocks: {
        default: [
          {
            component: 'Text',
            props: {
              class: 'post__content post__content-plot',
            },
            data: {
              content: this.customFields.communication,
            },
          },

          {
            component: 'Flex',
            props: {
              justifyContent: 'space-around',
              flexWrap: 'wrap',
              gap: '3rem 0rem',
              class: 'post__features',
            },
            blocks: {
              default: this.customFields.features.map((item, index) => {
                return {
                  component: 'Flex',
                  props: {
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '0rem',
                    class: 'post__features-areas',
                  },
                  blocks: {
                    default: [
                      {
                        component: 'Image',
                        data: {
                          image: item.icon,
                        },
                        props: {
                          class: '',
                        },
                      },
                      {
                        component: 'Text',
                        data: {
                          content: item.title,
                        },

                        props: {
                          class: 'post__features-title',
                        },
                      },
                      {
                        component: 'Text',
                        data: {
                          content: item.subtitle,
                        },

                        props: {
                          class: 'post__features-subtitle',
                        },
                      },
                    ],
                  },
                }
              }),
            },
          },
        ],
      },
    },

    // Headline section
    {
      component: 'Section',
      props: {
        class: '',
        width: 'full',
      },
      blocks: {
        default: [
          {
            component: 'Text',
            props: {
              class: 'post__headline',
            },
            data: {
              content: this.customFields.headline,
            },
          },
        ],
      },
    },

    // Full width image
    {
      component: 'Section',
      props: {
        class: 'post__wide-image',
        width: 'small',
      },
      blocks: {
        default: [
          {
            component: 'Image',
            data: {
              image: this.customFields.wide.image,
            },
          },
          {
            component: 'Text',
            data: {
              content: this.customFields.wide.content,
            },
            props: {
              class: 'post__additional-info-text',
            },
          },
        ],
      },
    },

    // Split column images
    {
      component: 'Section',
      props: {
        class: 'post__plot',
        width: 'small',
      },
      blocks: {
        default: {
          component: 'Grid',
          props: {
            class: '',
          },
          blocks: {
            default: this.customFields.images.map((item, index) => {
              return {
                component: 'Flex',
                props: {
                  flexDirection: 'column',
                },
                blocks: {
                  default: [
                    {
                      component: 'Image',
                      data: {
                        image: item.image,
                      },
                      props: {
                        class: 'post__additional-info-image',
                      },
                    },
                    {
                      component: 'Text',
                      data: {
                        content: item.content,
                      },
                      props: {
                        class: 'post__additional-info-text',
                      },
                    },
                  ],
                },
              }
            }),
          },
        },
      },
    },

    // Headline section
    {
      component: 'Section',
      props: {
        class: '',
        width: 'full',
      },
      blocks: {
        default: [
          {
            component: 'Text',
            props: {
              class: 'post__headline',
            },
            data: {
              content: this.customFields.headline2,
            },
          },
        ],
      },
    },

    // Full width image
    {
      component: 'Section',
      props: {
        class: 'post__wide-image',
        width: 'small',
      },
      blocks: {
        default: [
          {
            component: 'Image',
            props: {
              class: '',
            },
            data: {
              image: this.customFields.wide2.image,
            },
          },
          {
            component: 'Text',
            data: {
              content: this.customFields.wide2.content,
            },
            props: {
              class: 'post__additional-info-text',
            },
          },
        ],
      },
    },

    // Split column images
    {
      component: 'Section',
      props: {
        class: 'post__columns',
        width: 'small',
      },
      blocks: {
        default: {
          component: 'Grid',
          props: {
            class: '',
          },
          blocks: {
            default: this.customFields.images2.map((item, index) => {
              return {
                component: 'Flex',
                props: {
                  flexDirection: 'column',
                },
                blocks: {
                  default: [
                    {
                      component: 'Image',
                      data: {
                        image: item.image,
                      },
                      props: {
                        class: 'post__additional-info-image',
                      },
                    },
                    {
                      component: 'Text',
                      data: {
                        content: item.content,
                      },
                      props: {
                        class: 'post__additional-info-text',
                      },
                    },
                  ],
                },
              }
            }),
          },
        },
      },
    },

    // Call to action bottom
    {
      component: 'Section',
      props: {
        width: 'small',
        class: 'post__cta',
      },
      blocks: {
        default: [
          {
            component: 'Text',
            props: {
              class: 'post__cta-text',
            },
            data: {
              content: this.customFields.callToAction,
            },
          },
        ],
      },
    },
  ]
}
